import axios, { AxiosHeaders } from 'axios'

const API_URL = import.meta.env.VITE_API_URL

type TTokenResponse = {
  token?: string
}

const PrivateAPI = axios.create({
  baseURL: API_URL,
})

PrivateAPI.interceptors.request.use((config) => {
  const authToken = window.localStorage.getItem('authToken')
  const headers = AxiosHeaders.from(config.headers)
  const hasAuthorizationHeader = Boolean(headers.get('Authorization'))

  if (!authToken && !hasAuthorizationHeader) {
    throw new Error('Must supply authorization header')
  }

  if (!hasAuthorizationHeader && authToken) {
    headers.set('Authorization', `Bearer ${authToken}`)
  }

  config.headers = headers

  return config
})

PrivateAPI.interceptors.response.use(
  (response) => {
    const token = (response.data as TTokenResponse | undefined)?.token

    if (token) {
      window.localStorage.setItem('authToken', token)
    }

    return response
  },
  async (error) => {
    if (error?.response?.status === 401) {
      window.localStorage.removeItem('authToken')
      window.location.assign('/login')
    }

    throw error
  },
)

export { PrivateAPI }
